/**
 * Enum for Kds Order Item Status.
 * @readonly
 * @enum {String} KdsOrderItemStatusEnum
 */

const KdsOrderItemStatusEnum = {
  OPEN    : 'open',
  START   : 'start',
  HOLD    : 'hold',
  COMPLETE: 'complete',
  CANCEL  : 'cancel'
}

export default KdsOrderItemStatusEnum
